import emailjs from '@emailjs/browser';

// EmailJS Configuration using environment variables for security
export const EMAILJS_CONFIG = {
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    TEMPLATE_ID_CONTACT: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT,
    TEMPLATE_ID_CHATBOT: process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CHATBOT,
    PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

// Initialize EmailJS (call this once when app starts)
export const initEmailJS = () => {
    try {
        emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
        if (process.env.NODE_ENV !== 'production') {
            console.log('✅ EmailJS initialized successfully');
        }
    } catch (error) {
        console.error('❌ EmailJS initialization failed:', error);
    }
};

// Send contact form email
export const sendContactEmail = async (formData) => {
    try {
        const templateParams = {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            message: formData.message,
            to_email: 'gulfneuron@gmail.com', // ← Change this to your email
        };

        // NOTE: We don't pass PUBLIC_KEY here because we already initialized it
        const response = await emailjs.send(
            EMAILJS_CONFIG.SERVICE_ID,
            EMAILJS_CONFIG.TEMPLATE_ID_CONTACT,
            templateParams
        );

        if (process.env.NODE_ENV !== 'production') {
            console.log('✅ Contact email sent successfully:', response);
        }
        return { success: true, response };
    } catch (error) {
        console.error('❌ EmailJS Contact Form Error:', error);
        if (process.env.NODE_ENV !== 'production') {
            console.error('Error details:', {
                status: error.status,
                text: error.text,
                serviceId: EMAILJS_CONFIG.SERVICE_ID,
                templateId: EMAILJS_CONFIG.TEMPLATE_ID_CONTACT,
            });
        }
        return { success: false, error: error.text || 'Failed to send email' };
    }
};

// Send chatbot collected information email
export const sendChatbotEmail = async (chatData) => {
    try {
        const templateParams = {
            name: chatData.name,
            email: chatData.email,
            phone: chatData.phone,
            inquiry: chatData.inquiry,
            to_email: 'gulfneuron@gmail.com', // ← Change this to your email
        };

        // NOTE: We don't pass PUBLIC_KEY here because we already initialized it
        const response = await emailjs.send(
            EMAILJS_CONFIG.SERVICE_ID,
            EMAILJS_CONFIG.TEMPLATE_ID_CHATBOT,
            templateParams
        );

        if (process.env.NODE_ENV !== 'production') {
            console.log('✅ Chatbot email sent successfully:', response);
        }
        return { success: true, response };
    } catch (error) {
        console.error('❌ EmailJS Chatbot Error:', error);
        if (process.env.NODE_ENV !== 'production') {
            console.error('Error details:', {
                status: error.status,
                text: error.text,
                serviceId: EMAILJS_CONFIG.SERVICE_ID,
                templateId: EMAILJS_CONFIG.TEMPLATE_ID_CHATBOT,
            });
        }
        return { success: false, error: error.text || 'Failed to send email' };
    }
};